export default {
    headers: {
        "Accept": "application/vnd.solo.v1+json",
        "Content-Type": "application/json"
    },
    baseURL: 'https://api.solo.skylinedynamics.com',
    translationURL: 'https://api.mcx.skylinedynamics.com/public/projects/solo-apps/dataTypes/solo-mobile-apps/items',        
    appReady: false
}
